import { useSelector, shallowEqual } from 'react-redux';
import { useMemo } from 'react';
import type { RootState } from '../store';

const builderSelector = ({ builder, loading }: RootState) => ({
  selected: builder?.selected,
  editor: builder.editor,
  badges: builder?.badges,
  flatOutline: builder?.flatOutline,
  watchQueryParams: builder?.watchQueryParams,
  alwaysRenderInBuilder: builder?.alwaysRenderInBuilder,
  pageMap: builder?.pageMap,
  loading: (loading as Record<string, boolean>)[builder?.selected] || false,
  selectedComponent: builder?.flatOutline[builder?.selected] || null,
});

export const useBuilder = () => {
  const builderData = useSelector(builderSelector, shallowEqual);
  return useMemo(() => builderData, [builderData]);
};
